import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import * as Yup from 'yup';
import i18n from 'i18n-js';
import Grid from '@material-ui/core/Grid';
import { BaseModal } from 'components/UI';
import { useDispatch, useSelector } from 'react-redux';
import { Formik, Form, Field } from 'formik';
import { TextField } from 'components/FormFields';
import { InvoiceActions } from 'state/modules/invoice';
import { sumBy } from 'lodash';
import { formatAmount } from 'utils';
import useStyle from './Refund.styled';

const RefundModal = ({ open, invoices, handleClick }) => {
  const formSchema = Yup.object().shape({
    confirm: Yup.string()
      .required(i18n.t('common.required_field'))
      .oneOf(['REFUND', null], i18n.t('common.invalid_value')),
  });

  const { fetchingRefund, fetchedRefund } = useSelector((state) => state.invoice);

  const classes = useStyle();

  const formRef = useRef(null);
  const dispatch = useDispatch();
  const [totalRefund, setTotalRefund] = useState();

  const onSubmit = () => {
    formRef.current.submitForm();
  };

  const initialValues = {
    confirm: '',
  };

  useEffect(() => {
    if (invoices && invoices.length) {
      setTotalRefund(sumBy(invoices, 'invoiced') || 0);
    }
  }, [invoices]);

  useEffect(() => {
    if (fetchedRefund) {
      handleClick('success');
    }
  }, [fetchedRefund, handleClick]);

  return (
    <BaseModal
      size="sm"
      open={open}
      hasEnterButton
      hasCancelButton
      loading={fetchingRefund}
      onEnter={onSubmit}
      onCancel={handleClick}
      enableCloseButton={false}
      handleClick={handleClick}
      enterButtonLabel={i18n.t('invoice.refund')}
      title={i18n.t('invoice.refund')}
    >
      <Formik
        innerRef={formRef}
        initialValues={initialValues}
        onSubmit={() => {
          dispatch(
            InvoiceActions.fetchRefund({
              invoice_ids: invoices.map((row) => row.id),
            })
          );
        }}
        validationSchema={formSchema}
      >
        {({ handleSubmit }) => (
          <Form noValidate onSubmit={handleSubmit} autoComplete="off">
            <Grid data-cy="refund" container spacing={2}>
              <Grid item xs={8}>
                <b>{i18n.t('invoice.total_refunded')}</b>
              </Grid>
              <Grid item xs={4}>
                <span className={classes.total}>{`$${formatAmount(totalRefund)}`}</span>
              </Grid>
              <Grid item xs={12}>
                {i18n.t('invoice.refund_description_1')}
                <span className={classes.refund}> "{i18n.t('invoice.refund_description_2')}" </span>
                {i18n.t('invoice.refund_description_3')}
                <Field type="text" name="confirm" component={TextField} label={''} />
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </BaseModal>
  );
};

RefundModal.propTypes = {
  invoices: PropTypes.array,
  open: PropTypes.bool.isRequired,
  handleClick: PropTypes.func.isRequired,
};

RefundModal.defaultProps = {
  open: false,
  invoices: [],
  handleClick: () => {},
};

export default RefundModal;
